(function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.cozy-categories--swiper').forEach(function (el) {
    if (el.classList.contains('swiper-initialized')) return;

    var scope = el.closest('.cozy-categories--section') || document;

    var perView = parseInt(el.dataset.perView, 10) || 4;

    new Swiper(el, {
      wrapperClass: 'cozy-categories--swiper--wrapper',
      slideClass: 'cozy-category',
      slidesPerView: 1.5,
      spaceBetween: 4,
      loop: false,
      breakpoints: {
        750: {
          slidesPerView: Math.min(2.5, perView),
        },
        1024: {
          slidesPerView: perView,
        },
      },
      navigation: {
        nextEl: Array.from(scope.querySelectorAll('.cozy-categories--next')),
        prevEl: Array.from(scope.querySelectorAll('.cozy-categories--prev')),
        disabledClass: 'disabled',
      },
    });
  });
})();
